import { UserIdentityFlowAction, type IdentityOrchestratorFlowDescriptor } from "@/services/UserIdentitiesService";

/**
 * Mapa de equivalencia string → enum.
 * Cubre tanto los strings canónicos del contrato de backend como los valores numéricos
 * que pueda devolver data.action
 */
const FLOW_ACTION_STRING_MAP: Record<string, UserIdentityFlowAction> =
{
    StartNewOnboarding: UserIdentityFlowAction.StartNewOnboarding,
    ResumeDraft: UserIdentityFlowAction.ResumeDraft,
    RequestAccess: UserIdentityFlowAction.RequestAccess,
    InformationManualSignUpRequired: UserIdentityFlowAction.InformationManualSignUpRequired,
    RequestOwnershipTransfer: UserIdentityFlowAction.RequestOwnershipTransfer,
    AutomaticOwnershipTransfer: UserIdentityFlowAction.AutomaticOwnershipTransfer,
    ReactivateOwn: UserIdentityFlowAction.ReactivateOwn,
    AcceptTransferOwnership: UserIdentityFlowAction.AcceptTransferOwnership
};

/**
 * Normaliza un valor de acción de flujo (string o número) al enum interno.
 * Devuelve null si el valor no es reconocido.
 */
function normalizeActionValue(value: unknown): UserIdentityFlowAction | null
{
    if(value === null || value === undefined)
    {
        return null;
    }
    if(typeof value === "number" && value in UserIdentityFlowAction)
    {
        return value as UserIdentityFlowAction;
    }
    if(typeof value === "string")
    {
        const mapped = FLOW_ACTION_STRING_MAP[value];
        if(mapped !== undefined)
        {
            return mapped;
        }
        const asNumber = Number(value);
        if(!Number.isNaN(asNumber) && asNumber in UserIdentityFlowAction)
        {
            return asNumber as UserIdentityFlowAction;
        }
    }
    return null;
}

/**
 * Resuelve la acción efectiva de flujo para un envelope del orquestador.
 *
 * Prioridad:
 *   1. flow.action  (navegación explícita del backend)
 *   2. dataAction   (campo action dentro de data, p. ej. UserIdentityStatusDto.action)
 *   3. null         (sin flujo especial → comportamiento por defecto)
 */
export function resolveEffectiveFlowAction(flow: IdentityOrchestratorFlowDescriptor | undefined, dataAction?: unknown): UserIdentityFlowAction | null
{
    const fromFlow = normalizeActionValue(flow?.action);
    if(fromFlow !== null)
    {
        return fromFlow;
    }
    return normalizeActionValue(dataAction);
}